import { useContext } from 'react'
import { UserDispatchContext, UserStateContext } from '.'

export function useUser() {
  const { idleState } = useContext(UserStateContext)
  const { setIdleState } = useContext(UserDispatchContext)
  return { idleState, setIdleState }
}
